import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "errors",
  "use": "errors-usage",
  "viewBox": "0 0 15.4 13.33",
  "content": "<symbol viewBox=\"0 0 15.4 13.33\" id=\"errors\"><title>ErrorAsset 1</title><path d=\"M7.7,0,0,13.33H15.4Zm0,1.5,6.4,11.08H1.3Z\" /><path d=\"M7.7,9.08a.38.38,0,0,0,.38-.37V4.57a.37.37,0,0,0-.75,0V8.7A.38.38,0,0,0,7.7,9.08Z\" /><circle cx=\"7.7\" cy=\"10.66\" r=\"0.71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol